import Taro, {
  clearStorageSync,
  getStorageSync,
  removeStorageSync,
  setStorageSync,
} from '@tarojs/taro';

import { useUserStore } from '@/stores/user';
import { initStoreEnv } from './tool/localStore';

/**
 * key前缀
 */
export const keyPrefix = '_LY_SPM_MinApp';

/**
 * 存储信息
 */
export const storageInfo = {
  keys: [] as string[],
};

/**
 * 版本号
 */
export const version = '1.0.0';

/**
 * 本次更新是否重新登录
 */
export const isReLogin = true;

export const versionKey = `${keyPrefix}_Version`;

/**
 * 本地版本
 */
export const localVersion = getStorageSync(versionKey);

/**
 * 是否新版本
 */
export const isNewVersion = localVersion !== version;

const storeKeys = `${keyPrefix}_STORE_KEYS`;

/**
 * 获取存储keys
 */
export function getStoragekeys() {
  storageInfo.keys =
    ((getStorageSync(storeKeys) as string) || '').split(',') ||
    storageInfo.keys;
  return storageInfo.keys;
}

/**
 * 更新存储keys
 */
export function updateStoragekeys(key: string) {
  if (storageInfo.keys.includes(key)) {
    return;
  }
  storageInfo.keys.push(key);
  setStorageSync(storeKeys, storageInfo.keys.join(','));
}

export const resetStorage = () => {
  // 清除数据,用户数据
  [...getStoragekeys(), `${keyPrefix}_token`, '_app_share_data'].forEach(
    function (key) {
      removeStorageSync(key);
    }
  );
};

/**
 * 重新登录初始化数据
 */
if (isNewVersion && isReLogin) {
  resetStorage();
}

export const initEnv = (): void => {
  // 更新版本
  setStorageSync(versionKey, version);

  // 初始化本地存储
  initStoreEnv({
    prefix: `${keyPrefix}_cache_store`,
    keys: {
      token: `${keyPrefix}_token`,
    },
    global: Taro,
    setStorage: (key: string, data: string) => setStorageSync(key, data),
    getStorage: (key: string) => getStorageSync(key),
    removeStorage: (key: string) => removeStorageSync(key),
    clearStorage: () => clearStorageSync(),
  });
};

// 退出登录状态
const exitSystem = (mode?: number, url: string = '') => {
  // 重置用户登录状态
  const userStore = useUserStore();
  userStore.token = '';
  userStore.isLogin = false;

  // 移除本地存储
  resetStorage();
};
Taro.eventCenter.on('exitSystem', exitSystem);
